module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "qz-search-wrap"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词",
      "show-action": ""
    },
    on: {
      "search": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        return _vm.onSearch(_vm.keywords)
      }
    },
    slot: "action"
  }, [_vm._v("搜索")])])], 1), _vm._v(" "), (!_vm.keywords && _vm.history_list.length > 0) ? _c('div', {
    staticClass: "search-default"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("搜索历史 "), _c('em', {
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.emptyHistory
    }
  }, [_vm._v("清除")])]), _vm._v(" "), _c('div', {
    staticClass: "cf"
  }), _vm._v(" "), _c('ul', {
    staticClass: "result cf"
  }, _vm._l((_vm.history_list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.onSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cf"
  })]) : _vm._e(), _vm._v(" "), (_vm.emptyShow) ? _c('div', {}, [_c('van-empty', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "description": "暂无结果"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11b79028","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/SearchAll.vue
// module id = 1148
// module chunks = 0